import React from 'react';
import ReactDOM from 'react-dom';
import {createHashHistory} from 'history';

import {Router, Route, useRouterHistory, IndexRedirect} from 'react-router'

import {syncHistoryWithStore} from 'mobx-react-router';

import {Provider} from 'mobx-react';
import allStore from './stores/index'

import './style';
import Login from './components/init/Login';
import Price from "./components/price/Price";
import AppInfo from "./components/price//AppInfo";
import Home from './components/home/Home';
import Order from './components/order/index';
import OrderWfE8 from './components/order/OrderWfE8';
import Collect from './components/collect/index';
import Authority from "./components/setting/Authority";
import DevPortal from './components/dev/DevPortal';
import DevApply from './components/dev/devApply/index';
import OcQues from './components/oc/OcQues';
import DevDoc from './components/oc/DevDoc';
import ComponentDocBasic from './components/oc/componentDoc/Basic';
import ComponentDocBusiness from './components/oc/componentDoc/Business';
import SysPortal from './components/sys/SysPortal';
import User from './components/sys/basic/User';
import UserPwd from './components/sys/basic/UserPwd';
import UserList from './components/sys/user/UserList';
import ChangeRole from './components/sys/user/ChangeRole';
import UserOnlineList from './components/sys/user/UserOnlineList';
import UserDevApplyList from './components/sys/user/UserDevApplyList';
import JoinList from './components/sys/user/JoinList';
import AppApplyList from './components/sys/app/AppApplyList';
import DevApplyList from './components/sys/app/DevApplyList';
import FbAppList from './components/sys/app/FbAppList';
import Publish from './components/sys/sysManager/Publish';
import Module from './components/sys/sysManager/Module';
import Ind from './components/sys/sysManager/Ind';
import BarChart from './components/sys/statistics/BarChart';
import AllEcodeDemo from './components/sys/ecodeDemo/index';
import EcodeDev from './components/dev/EcodeDev';
import EcodeGenre from './components/sys/ecodeGenre';
import MyCollect from './components/collect/MyCollect';

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);

class Root extends React.Component {
  render() {
    return (
      <Provider {...allStore}>
        <Router history={history}>
          <Route name="login" breadcrumbName="登录" path="login" component={Login}></Route>
          <Route name="/" breadcrumbName="首页" path="/" component={Home}>
            <IndexRedirect to="app" />
            <Route name="app" breadcrumbName="我的应用" path="app">
              <IndexRedirect to="order" />
              <Route name="order" breadcrumbName="我的订单" path="order" component={Order}/>
              <Route name="price" breadcrumbName="应用报价" path="price" component={Price}/>
              <Route name="collect" breadcrumbName="我的收藏" path="collect" component={Collect} />
              <Route name="mycollection" breadcrumbName="ecode收藏" path="collect/mycollection" component={MyCollect}/>
            </Route>
            <Route name="manager" breadcrumbName="应用管理" path="manager">
              <IndexRedirect to="price" />
              <Route name="price" breadcrumbName="应用报价" path="price" component={Price}/>
              <Route name="appInfo" breadcrumbName="应用信息维护" path="appInfo" component={AppInfo}/>
            </Route>
            <Route name="setting" breadcrumbName="应用管理" path="setting">
              <IndexRedirect to="authority" />
              <Route name="authority" breadcrumbName="权限设置" path="authority" component={Authority}/>
            </Route>
            {/*<Route name="log" breadcrumbName="日志" path="log">*/}
              {/*<IndexRedirect to="query"/>*/}
              {/*<Route name="query" breadcrumbName="日志查询" path="query" component={Log}/>*/}
            {/*</Route>*/}
            <Route name="dev" breadcrumbName="开发者" path="dev">
              <IndexRedirect to="ecodeDev" />
              <Route name="list" breadcrumbName="应用列表" path="list" component={DevPortal}/>
              <Route name="devApply" breadcrumbName="发布应用" path="apply" component={DevApply} />
              <Route name="devAppShow" breadcrumbName="更新应用" path=":id/show" component={DevApply} />
              <Route name="ecodeDev" breadcrumbName="ecode授权" path="ecodeDev" component={EcodeDev} />
            </Route>
            {/* <Route name="oc" breadcrumbName="社区" path="oc">
              <IndexRedirect to="ques" />
              <Route name="ques" breadcrumbName="常见问题" path="ques">
                <Route name="ques_1" breadcrumbName="" path="ques_1" component={OcQues} />
              </Route>
              <Route name="devDoc" breadcrumbName="开发文档" path="devDoc">
                <Route name="devDoc_1" breadcrumbName="" path="devDoc_1" component={DevDoc} />
              </Route>
              <Route name="componentDoc" breadcrumbName="组件文档" path="componentDoc">
                <IndexRedirect to="basic" />
                <Route name="basic" breadcrumbName="基础组件" path="basic" component={ComponentDocBasic} />
                <Route name="business" breadcrumbName="业务组件" path="business" component={ComponentDocBusiness} />
              </Route>
            </Route> */}
            <Route name="sys" breadcrumbName="后台" path="sys" component={SysPortal}>
              <Route name="basic" breadcrumbName="基础管理" path="basic">
                <IndexRedirect to="user" />
                <Route name="user" breadcrumbName="基本信息" path="user" component={User} />
                <Route name="userPwd" breadcrumbName="密码修改" path="userPwd" component={UserPwd} />
              </Route>
              <Route name="user" breadcrumbName="用户管理" path="user">
                <Route name="userList" breadcrumbName="用户列表" path="userList" component={UserList} />
                <Route name="changeRole" breadcrumbName="修改用户信息" path="changeRole" component={ChangeRole} />
                <Route name="userOnlineList" breadcrumbName="登录状态" path="userOnlineList" component={UserOnlineList} />
                <Route name="userDevApplyList" breadcrumbName="开发者审核" path="userDevApplyList" component={UserDevApplyList} />
                <Route name="joinList" breadcrumbName="注册列表" path="joinList" component={JoinList} />
              </Route>
              <Route name="app" breadcrumbName="应用管理" path="app">
                <Route name="appApplyList" breadcrumbName="订单审核" path="appApplyList" component={AppApplyList} />
                <Route name="devApplyList" breadcrumbName="发布审核" path="devApplyList" component={DevApplyList} />
                <Route name="fbAppList" breadcrumbName="非标应用" path="fbAppList" component={FbAppList} />
              </Route>
              <Route name="sysManager" breadcrumbName="系统管理" path="sysManager">
                <Route name="publish" breadcrumbName="发布版本" path="publish" component={Publish} />
                <Route name="module" breadcrumbName="类别管理" path="module" component={Module} />
                <Route name="ind" breadcrumbName="行业管理" path="ind" component={Ind} />
              </Route>
              <Route name="statistics" breadcrumbName="访问统计" path="statistics">
                <Route name="barchart" breadcrumbName="访问量" path="barchart" component={BarChart} />
              </Route>
            </Route>
            <Route name="ecodeDemo" breadcrumbName="云案例共享" path="ecodeDemo" component={SysPortal}>
              <IndexRedirect to="all" />
              <Route name="all" breadcrumbName="全部案例" path="all" component={AllEcodeDemo} />
              <Route name="success" breadcrumbName="已通过" path="success" component={AllEcodeDemo} />
              <Route name="fail" breadcrumbName="未通过" path="fail" component={AllEcodeDemo} />
              <Route name="applying" breadcrumbName="审核中" path="applying" component={AllEcodeDemo} />
              <Route name="downloadlog" breadcrumbName="下载日志" path="downloadlog" component={AllEcodeDemo} />
              <Route name="tagmanage" breadcrumbName="标签管理" path="tagmanage" component={AllEcodeDemo} />
              <Route name="demorenew" breadcrumbName="案例恢复" path="demorenew" component={AllEcodeDemo} />
              <Route name="cusdownloadlog" breadcrumbName="客户下载日志" path="cusdownloadlog" component={AllEcodeDemo} />
              <Route name="memberlist" breadcrmbName="添加协作人" path="memberlist" component={AllEcodeDemo}/>
              <Route name ="ecoderole" breadcrmbName="协作人管理" path="ecoderole" component={AllEcodeDemo} />
              <Route name="appmanage" breadcrmbName="应用管理" path="appmanage" component={AllEcodeDemo} />
              <Route name="privateEcode" breadcrmbName="应用管理" path="privateEcode" component={AllEcodeDemo} />
              <Route name="ecodegenre" breadcrmbName="行业职能管理" path="ecodegenre" component={EcodeGenre} />
          </Route>
          </Route>
        </Router>
      </Provider>
    )
  }
}

setTimeout(function() {
  try {
    ReactDOM.render(<Root/>, document.getElementById('root'));
  } catch(e) {
    //console.log("render出错：" + e);
  }
}, window.debug ? 100 : 0);

// setInterval(function () {
//   try {
//     allStore.initStore.checkToken();
//   } catch(e) {
//     //console.log("render出错：" + e);
//   }
// },3000);


// WEBPACK FOOTER //
// ./src/index.js